"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceType2 = exports.PlaceType1 = void 0;
/**
 * Table 1: Types supported in place search and addition
 *
 * You can use the following values in the types filter for place searches and when adding a place.
 *
 * @see https://developers.google.com/places/web-service/supported_types#table1
 */
var PlaceType1;
(function (PlaceType1) {
    PlaceType1["accounting"] = "accounting";
    /** indicates an airport. */
    PlaceType1["airport"] = "airport";
    PlaceType1["amusement_park"] = "amusement_park";
    PlaceType1["aquarium"] = "aquarium";
    PlaceType1["art_gallery"] = "art_gallery";
    PlaceType1["atm"] = "atm";
    PlaceType1["bakery"] = "bakery";
    PlaceType1["bank"] = "bank";
    PlaceType1["bar"] = "bar";
    PlaceType1["beauty_salon"] = "beauty_salon";
    PlaceType1["bicycle_store"] = "bicycle_store";
    PlaceType1["book_store"] = "book_store";
    PlaceType1["bowling_alley"] = "bowling_alley";
    PlaceType1["bus_station"] = "bus_station";
    PlaceType1["cafe"] = "cafe";
    PlaceType1["campground"] = "campground";
    PlaceType1["car_dealer"] = "car_dealer";
    PlaceType1["car_rental"] = "car_rental";
    PlaceType1["car_repair"] = "car_repair";
    PlaceType1["car_wash"] = "car_wash";
    PlaceType1["casino"] = "casino";
    PlaceType1["cemetery"] = "cemetery";
    PlaceType1["church"] = "church";
    PlaceType1["city_hall"] = "city_hall";
    PlaceType1["clothing_store"] = "clothing_store";
    PlaceType1["convenience_store"] = "convenience_store";
    PlaceType1["courthouse"] = "courthouse";
    PlaceType1["dentist"] = "dentist";
    PlaceType1["department_store"] = "department_store";
    PlaceType1["doctor"] = "doctor";
    PlaceType1["drugstore"] = "drugstore";
    PlaceType1["electrician"] = "electrician";
    PlaceType1["electronics_store"] = "electronics_store";
    PlaceType1["embassy"] = "embassy";
    PlaceType1["fire_station"] = "fire_station";
    PlaceType1["florist"] = "florist";
    PlaceType1["funeral_home"] = "funeral_home";
    PlaceType1["furniture_store"] = "furniture_store";
    PlaceType1["gas_station"] = "gas_station";
    PlaceType1["gym"] = "gym";
    PlaceType1["hair_care"] = "hair_care";
    PlaceType1["hardware_store"] = "hardware_store";
    PlaceType1["hindu_temple"] = "hindu_temple";
    PlaceType1["home_goods_store"] = "home_goods_store";
    PlaceType1["hospital"] = "hospital";
    PlaceType1["insurance_agency"] = "insurance_agency";
    PlaceType1["jewelry_store"] = "jewelry_store";
    PlaceType1["laundry"] = "laundry";
    PlaceType1["lawyer"] = "lawyer";
    PlaceType1["library"] = "library";
    PlaceType1["light_rail_station"] = "light_rail_station";
    PlaceType1["liquor_store"] = "liquor_store";
    PlaceType1["local_government_office"] = "local_government_office";
    PlaceType1["locksmith"] = "locksmith";
    PlaceType1["lodging"] = "lodging";
    PlaceType1["meal_delivery"] = "meal_delivery";
    PlaceType1["meal_takeaway"] = "meal_takeaway";
    PlaceType1["mosque"] = "mosque";
    PlaceType1["movie_rental"] = "movie_rental";
    PlaceType1["movie_theater"] = "movie_theater";
    PlaceType1["moving_company"] = "moving_company";
    PlaceType1["museum"] = "museum";
    PlaceType1["night_club"] = "night_club";
    PlaceType1["painter"] = "painter";
    /** indicates a named park. */
    PlaceType1["park"] = "park";
    PlaceType1["parking"] = "parking";
    PlaceType1["pet_store"] = "pet_store";
    PlaceType1["pharmacy"] = "pharmacy";
    PlaceType1["physiotherapist"] = "physiotherapist";
    PlaceType1["plumber"] = "plumber";
    PlaceType1["police"] = "police";
    PlaceType1["post_office"] = "post_office";
    PlaceType1["real_estate_agency"] = "real_estate_agency";
    PlaceType1["restaurant"] = "restaurant";
    PlaceType1["roofing_contractor"] = "roofing_contractor";
    PlaceType1["rv_park"] = "rv_park";
    PlaceType1["school"] = "school";
    PlaceType1["secondary_school"] = "secondary_school";
    PlaceType1["shoe_store"] = "shoe_store";
    PlaceType1["shopping_mall"] = "shopping_mall";
    PlaceType1["spa"] = "spa";
    PlaceType1["stadium"] = "stadium";
    PlaceType1["storage"] = "storage";
    PlaceType1["store"] = "store";
    PlaceType1["subway_station"] = "subway_station";
    PlaceType1["supermarket"] = "supermarket";
    PlaceType1["synagogue"] = "synagogue";
    PlaceType1["taxi_stand"] = "taxi_stand";
    PlaceType1["tourist_attraction"] = "tourist_attraction";
    PlaceType1["train_station"] = "train_station";
    PlaceType1["transit_station"] = "transit_station";
    PlaceType1["travel_agency"] = "travel_agency";
    PlaceType1["university"] = "university";
    PlaceType1["veterinary_care"] = "veterinary_care";
    PlaceType1["zoo"] = "zoo";
})(PlaceType1 || (exports.PlaceType1 = PlaceType1 = {}));
/**
 * Table 2: Additional types returned by the Places service
 *
 * The following types may be returned in the results of a place search, in addition to the types in table 1 above.
 * For more details on these types, refer to [Address Types](https://developers.google.com/maps/documentation/geocoding/intro#Types)
 * in Geocoding Responses.
 *
 * @see https://developers.google.com/places/web-service/supported_types#table2
 */
var PlaceType2;
(function (PlaceType2) {
    /**
     * indicates a first-order civil entity below the country level. Within the United States, these administrative levels are states.
     * Not all nations exhibit these administrative levels. In most cases, `administrative_area_level_1` short names will closely match
     * ISO 3166-2 subdivisions and other widely circulated lists; however this is not guaranteed as our geocoding results are based
     * on a variety of signals and location data.
     */
    PlaceType2["administrative_area_level_1"] = "administrative_area_level_1";
    /**
     * indicates a second-order civil entity below the country level. Within the United States, these administrative levels are counties.
     * Not all nations exhibit these administrative levels.
     */
    PlaceType2["administrative_area_level_2"] = "administrative_area_level_2";
    /**
     * indicates a third-order civil entity below the country level. This type indicates a minor civil division.
     * Not all nations exhibit these administrative levels.
     */
    PlaceType2["administrative_area_level_3"] = "administrative_area_level_3";
    /**
     * indicates a fourth-order civil entity below the country level. This type indicates a minor civil division.
     * Not all nations exhibit these administrative levels.
     */
    PlaceType2["administrative_area_level_4"] = "administrative_area_level_4";
    /**
     * indicates a fifth-order civil entity below the country level. This type indicates a minor civil division.
     * Not all nations exhibit these administrative levels.
     */
    PlaceType2["administrative_area_level_5"] = "administrative_area_level_5";
    PlaceType2["archipelago"] = "archipelago";
    /** indicates a commonly-used alternative name for the entity. */
    PlaceType2["colloquial_area"] = "colloquial_area";
    PlaceType2["continent"] = "continent";
    /** indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    PlaceType2["country"] = "country";
    PlaceType2["establishment"] = "establishment";
    PlaceType2["finance"] = "finance";
    PlaceType2["floor"] = "floor";
    PlaceType2["food"] = "food";
    PlaceType2["general_contractor"] = "general_contractor";
    PlaceType2["geocode"] = "geocode";
    PlaceType2["health"] = "health";
    /** indicates a major intersection, usually of two major roads. */
    PlaceType2["intersection"] = "intersection";
    PlaceType2["landmark"] = "landmark";
    /** indicates an incorporated city or town political entity. */
    PlaceType2["locality"] = "locality";
    /** indicates a prominent natural feature. */
    PlaceType2["natural_feature"] = "natural_feature";
    /** indicates a named neighborhood */
    PlaceType2["neighborhood"] = "neighborhood";
    PlaceType2["place_of_worship"] = "place_of_worship";
    PlaceType2["plus_code"] = "plus_code";
    PlaceType2["point_of_interest"] = "point_of_interest";
    /** indicates a political entity. Usually, this type indicates a polygon of some civil administration. */
    PlaceType2["political"] = "political";
    PlaceType2["post_box"] = "post_box";
    /** indicates a postal code as used to address postal mail within the country. */
    PlaceType2["postal_code"] = "postal_code";
    PlaceType2["postal_code_prefix"] = "postal_code_prefix";
    PlaceType2["postal_code_suffix"] = "postal_code_suffix";
    PlaceType2["postal_town"] = "postal_town";
    /** indicates a named location, usually a building or collection of buildings with a common name */
    PlaceType2["premise"] = "premise";
    PlaceType2["room"] = "room";
    /** indicates a named route (such as "US 101"). */
    PlaceType2["route"] = "route";
    PlaceType2["street_address"] = "street_address";
    PlaceType2["street_number"] = "street_number";
    /**
     * indicates a first-order civil entity below a locality. For some locations may receive one of the additional types:
     * `sublocality_level_1` to `sublocality_level_5`. Each sublocality level is a civil entity. Larger numbers indicate a smaller
     * geographic area.
     */
    PlaceType2["sublocality"] = "sublocality";
    PlaceType2["sublocality_level_1"] = "sublocality_level_1";
    PlaceType2["sublocality_level_2"] = "sublocality_level_2";
    PlaceType2["sublocality_level_3"] = "sublocality_level_3";
    PlaceType2["sublocality_level_4"] = "sublocality_level_4";
    PlaceType2["sublocality_level_5"] = "sublocality_level_5";
    /**
     * indicates a first-order entity below a named location, usually a singular building within a collection of buildings with a
     * common name.
     */
    PlaceType2["subpremise"] = "subpremise";
    PlaceType2["town_square"] = "town_square";
})(PlaceType2 || (exports.PlaceType2 = PlaceType2 = {}));
//# sourceMappingURL=google-maps-place-types.js.map